<template>
  <v-container class="bg-primary rounded-b-lg pa-5">
    <div class="d-flex justify-space-between align-center mb-3">
      <img src="/images/securite_logo_white.png" width="100" />
      <v-btn icon="mdi-swap-horizontal-bold" size="x-small" color="white" variant="flat" @click="rotateCard"></v-btn>
    </div>
    <div class="card" :style="{ height: cardHeight + 'px' }">
      <v-sheet color="#FFF" class="pa-5 rounded-lg card-side front elevation-4">
        <div>
          <div class="text-caption">口座残高</div>
        </div>
        <div class="d-flex align-center justify-space-between" :style="{ gap: '16px' }">
          <div class="d-flex align-left flex-column">
            <div>
              <span class="text-h6">{{ formattedDeposit }}</span>
              <span class="ml-1">円</span>
            </div>
            <div :style="color_style">{{ deposit_sign }}{{ formattedLeatestDeposit }} 円<span class="small">（{{
              formattedLeatestDepositDatetime }}）</span></div>
          </div>
          <div class="d-flex flex-column" :style="{ gap: '4px' }">
            <v-btn size="x-small" rounded="xl" elevation="0" variant="outlined" color="primary" @click="gotoWithdraw">履歴</v-btn>
            <v-btn size="x-small" rounded="xl" elevation="0" variant="outlined" color="primary" @click="gotoPayment">出金</v-btn>
            <v-btn size="x-small" rounded="xl" elevation="0" variant="outlined" color="primary" @click="hideContent">非表示</v-btn>
          </div>
        </div>

        <v-divider class="my-3">
        </v-divider>

        <div class="d-flex justify-space-between align-center" style="gap: 16px;">

          <div style="width: calc( 50% - 16px )">
            <div class="text-caption">運用中のファンド</div>
            <div class="text-right">
              <span class="text-h6 font-weight-bold text-primary">{{ formattedFunds }}</span>
              <span class="ml-1">本</span>
            </div>
          </div>

          <v-divider vertical></v-divider>

          <div style="width: calc( 50% - 16px )">
            <div class="text-caption">運用中の資金</div>
            <div class="text-right">
              <span class="text-h6">{{ formattedCapital }}</span>
              <span class="ml-1">円</span>
            </div>
          </div>

        </div>
      </v-sheet>

      <v-sheet color="#FFF" class="pa-5 rounded-lg card-side back elevation-4">
        <div>
          <div class="text-caption">生涯収益</div>
        </div>
        <div class="d-flex align-center justify-space-between" :style="{ gap: '16px' }">
          <div class="d-flex align-left flex-column">
            <div>
              <span class="text-h6">{{ formattedTotalDeposit }}</span>
              <span class="ml-1">円</span>
            </div>
          </div>
          <div class="d-flex flex-column" :style="{ gap: '4px' }">
            <v-btn size="x-small" rounded="xl" elevation="0" variant="outlined" color="primary" @click="gotoWithdraw">履歴</v-btn>
            <v-btn size="x-small" rounded="xl" elevation="0" variant="outlined" color="primary" @click="gotoPayment">出金</v-btn>
            <v-btn size="x-small" rounded="xl" elevation="0" variant="outlined" color="primary" @click="hideContent">非表示</v-btn>
          </div>
        </div>

        <v-divider class="my-3">
        </v-divider>

        <div class="d-flex justify-center align-center" style="gap: 16px;">

          <div style="width: calc( 50% - 16px )">
            <div class="text-caption">償還済みのファンド</div>
            <div class="text-right">
              <span class="text-h6 font-weight-bold text-primary">{{ formattedRedunds }}</span>
              <span class="ml-1">本</span>
            </div>
          </div>

          <v-divider vertical></v-divider>

          <div style="width: calc( 50% - 16px )">
            <div class="text-caption">寄付済みのファンド</div>
            <div class="text-right">
              <span class="text-h6 font-weight-bold text-primary">{{ formattedNoPayment }}</span>
              <span class="ml-1">本</span>
            </div>
          </div>

        </div>
      </v-sheet>
    </div>
  </v-container>

  <div v-if="false">{{ condition }}</div>
</template>

<style scoped>
.card {
  position: relative;
}

.card-side {
  width: 100%;
  height: 205px;
  transition: all 0.8s ease;
  position: absolute;
  backface-visibility: hidden;
  top: 0;
  left: 0;
}

.card-side.back {
  transform: rotateY(-180deg);
}

.card.rotated .card-side.front {
  transform: rotateY(180deg);
}

.card.rotated .card-side.back {
  transform: rotateY(0deg);
}
</style>

<script>
import axios from "axios"
import Helper from "../assets/js/helper"

export default {
  name: 'AccountPortfolio',
  components: {
  },
  data: () => ({
    'deposit': '-',
    'deposit_sign': '',
    'leatest_deposit': '-',
    'leatest_deposit_datetime': '-',
    'funds': '-',
    'capital': '-',
    'totalDeposit': '-',
    'refunds': '-',
    'noPayment': '-',
    'condition': '',
    'tmpDeposit': '-',
    'tmpLeatestDeposit': '-',
    'tmpDepositSign': '',
    'tmpLeatestDepositDatetime': '-',
    'tmpFunds': '-',
    'tmpCapital': '-',
    'tmpTotalDeposit': '-',
    'tmpRefunds': '-',
    'tmpNopayment': '-',
    'color_style': {
      'color': '#666'
    },
    'tmpColorStyle': {
      'color': '#666'
    },
    'cardHeight': 205,
  }),
  computed: {
    formattedDeposit: function () {
      return Helper.addComma(this.deposit)
    },
    formattedLeatestDeposit: function () {
      return Helper.addComma(this.leatest_deposit)
    },
    formattedLeatestDepositDatetime: function () {
      return Helper.formatDate(this.leatest_deposit_datetime)
    },
    formattedFunds: function () {
      return Helper.addComma(this.funds)
    },
    formattedCapital: function () {
      return Helper.addComma(this.capital)
    },
    formattedTotalDeposit: function () {
      return Helper.addComma(this.totalDeposit)
    },
    formattedRedunds: function () {
      return Helper.addComma(this.refunds)
    },
    formattedNoPayment: function () {
      return Helper.addComma(this.noPayment)
    },
  },
  // コンポーネントマウントリスナ
  async mounted() {
    this.fetchContent();
  },
  methods: {

    async fetchContent() {

      this.condition = 'requesting';
      const res = await axios.get('/api/account').catch(() => {
        this.condition = 'fail';
        return;
      });

      console.log(res);

      this.deposit = res.data.deposit
      this.leatest_deposit = res.data.leatest_deposit
      this.funds = res.data.funds
      this.capital = res.data.capital
      this.totalDeposit = res.data.total_deposit
      this.refunds = res.data.refunds
      this.noPayment = res.data.no_payment
      if (res.data.leatest_deposit_process == 'income') {
        this.deposit_sign = '+';
        this.color_style.color = 'green';
        this.leatest_deposit_datetime = res.data.leatest_deposit_datetime
      } else if (res.data.leatest_deposit_process == 'outcome' && this.leatest_deposit < 0 ) {
        this.deposit_sign = '-';
        this.color_style.color = 'red';
        this.leatest_deposit = this.leatest_deposit * -1;
        this.leatest_deposit_datetime = res.data.leatest_deposit_datetime
      } else {
        this.deposit_sign = '';
        this.color_style.color = '#666';
        this.leatest_deposit = '-';
      }

      // コンテンツロードを伝播する
      this.$nextTick(() => {
        this.$emit('content-loaded');
      });
    },
    hideContent() {
      [this.tmpDeposit, this.deposit] = [this.deposit, this.tmpDeposit];
      [this.tmpDepositSign, this.deposit_sign] = [this.deposit_sign, this.tmpDepositSign];
      [this.tmpLeatestDeposit, this.leatest_deposit] = [this.leatest_deposit, this.tmpLeatestDeposit];
      [this.tmpLeatestDepositDatetime, this.leatest_deposit_datetime] = [this.leatest_deposit_datetime, this.tmpLeatestDepositDatetime];
      [this.tmpFunds, this.funds] = [this.funds, this.tmpFunds];
      [this.tmpCapital, this.capital] = [this.capital, this.tmpCapital];
      [this.tmpColorStyle, this.color_style] = [this.color_style, this.tmpColorStyle];
      [this.tmpTotalDeposit, this.totalDeposit] = [this.totalDeposit, this.tmpTotalDeposit];
      [this.tmpRefunds, this.refunds] = [this.refunds, this.tmpRefunds];
      [this.noPayment, this.tmpNopayment] = [this.tmpNopayment, this.noPayment];
    },
    gotoDepositPage() {
      Helper.navigateTo('/mypage/deposit');
    },
    rotateCard() {
      const card = document.querySelector('.card');
      card.classList.toggle('rotated');
      // this.setCardHeight();
    },
    setCardHeight() {
      const cardContentFront = document.querySelector('.card .card-side.front');
      const cardContentBack = document.querySelector('.card .card-side.back');
      this.cardHeight = cardContentFront.clientHeight > cardContentBack.clientHeight ? cardContentFront.clientHeight : cardContentBack.clientHeight;
    },
    gotoWithdraw() {
      this.$router.replace({ name: 'contentViewer', query: { page_uri: '/mypage/withdrawal' } });
    },
    gotoPayment() {
      this.$router.replace({ name: 'contentViewer', query: { page_uri: '/mypage/withdrawal/payment' } });
    }
  }
}
</script>